import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { BaleInfo } from "./bale-info.entity";
import { BaleItems } from "./bale-items.entity";
import { BaleController } from "./bale.controller";
import { BaleService } from "./bale.service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { ProdlogService } from "libs/shared-services/production/src/lib/prod-log.service";
import { WorkOrderService } from "../work-order-generation/work-order.service";
import { WorkOrderInfo } from "../work-order-generation/work-order.entity";
import { WorkOrderItems } from "../work-order-generation/work-order-items.entity";
import { ProductionInventoryService } from "libs/shared-services/production/src/lib/production-inventory.service";
import { ActualBaleQtyLogs } from "./act-bale-qty-entity";
import { WarehouseDashboardService } from '@gtpl/shared-services/analytics';

@Module({
    imports:[
        TypeOrmModule.forFeature([BaleInfo,BaleItems,WorkOrderInfo,WorkOrderItems,ActualBaleQtyLogs])
    ],
    controllers:[BaleController],
    providers:[BaleService,ApplicationExceptionHandler,WorkOrderService,ProdlogService,ProductionInventoryService,WarehouseDashboardService],
    exports:[BaleService],
})
export class BaleModule{}